import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';
import { flexbox, layout } from 'styled-system';

import { Dropdown } from '@olist/design-system';
import { Box, Button, getColor } from '@olist/united';

export const Wrapper = styled(Box)`
  div:first-child {
    display: block;
  }

  button[data-ref='dropdown-toggle'] {
    border: 1px solid ${getColor('text', 'light', 2)};
    box-shadow: inset 0px 3px 3px rgba(0, 0, 0, 0.05);
    font-weight: normal;
    width: 100%;
  }
`;

export const SelectButton = styled(Button).attrs({
  'data-ref': 'dropdown-toggle',
  'data-testid': 'dropdown-toggle',
  justifyContent: 'space-between',
  maxWidth: '380px',
  type: 'button',
})`
  ${flexbox}
  ${layout}
`;

export const CheckboxWrapper = styled(Box).attrs({
  maxHeight: '464px',
  my: '15px',
})`
  &:first-child {
    margin-top: 0;
  }
`;

export const DropdownItem = styled(Dropdown.Item)<any>`
  background-color: ${({ isChecked }) =>
    isChecked ? themeGet('colors.foundation.primaryLight') : 'transparent'};
  border: 1px solid transparent;
  color: ${themeGet('colors.foundation.linkDark')};
  display: flex;
  font-size: 15px;
  padding: ${themeGet('space.2')}px ${themeGet('space.3')}px;
  width: 100%;

  &:hover {
    background-color: ${themeGet('colors.foundation.primaryLight')};
  }

  &:focus {
    outline: 0;
  }
`;
